import type { KcContext } from 'keycloakify/login/KcContext';

interface HasProfile {
    profile?: Record<string, unknown>;
}

/**
 * Safe getter for user profile attributes from kcContext.
 * It normalizes multiple value fields and returns first value or empty string.
 */
export function getProfileAttr(kcContext: KcContext | undefined, fieldName: string): string {
    const profile = (kcContext as unknown as HasProfile).profile;
    const raw = profile?.[fieldName];
    if (raw === undefined || raw === null) return '';
    if (Array.isArray(raw)) return raw[0] ? String(raw[0]) : '';
    return String(raw);
}
